module.exports = __webpack_public_path__ + "img/noia.f79bb7cb.svg";